<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Edition formation">
        <v-form v-if="formation.id" v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="6">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-text-field
                  v-model="formation.libelle"
                  label="Libellé"
                  @input="resetApiErrors('libelle')"
                  :error-messages="checkApiErrors('libelle')"
                  :rules="libelleRules"
                ></v-text-field>
              </template>
              <template v-else>
                <v-text-field
                  v-model="formation.libelle"
                  label="Libellé"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="12" md="2">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-checkbox
                  v-model="formation.eligible"
                  label="Eligible"
                ></v-checkbox>
              </template>
              <template v-else>
                <v-text-field
                  :value="formation.eligible ? 'oui' : 'non'"
                  label="Eligible"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-select
                  v-model="formation.diplome"
                  :items="itemsDiplome"
                  hint="Type du diplôme"
                  item-text="libelle"
                  item-value="id"
                  label="Choix du type de diplôme"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </template>
              <template v-else>
                <v-text-field
                  v-model="formation.diplome.libelle"
                  label="Type de diplôme"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="12" md="4" offset-md="2">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-select
                  v-model="formation.niveau"
                  :items="itemsNiveau"
                  hint="Niveau de la formation"
                  item-text="libelle"
                  item-value="id"
                  label="Choix du niveau de la formation"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </template>
              <template v-else>
                <v-text-field
                  v-model="formation.niveau.libelle"
                  label="Niveau de la formation"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-select
                  v-model="formation.structure"
                  :items="itemsStructure"
                  hint="Structure"
                  item-text="libelle"
                  item-value="id"
                  label="Select structure"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </template>
              <template v-else>
                <v-text-field
                  v-model="formation.structure.libelle"
                  label="Structure"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="12" md="6">
              <template v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
                <v-select
                  v-model="formation.campus"
                  :items="itemsCampus"
                  hint="Campus"
                  item-text="libelle"
                  item-value="id"
                  label="Select campus"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </template>
              <template v-else>
                <v-text-field
                  v-model="formation.campus.libelle"
                  label="Campus"
                  readonly
                  filled
                ></v-text-field>
              </template>
            </v-col>
          </v-row>

          <v-menu
            v-model="showCalendarDebut"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formatedDateOuverture"
                label="Date ouverture *"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
                autofocus
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="fr-fr"
              :min="minDateOuverture"
              :max="maxDateFermeture"
              v-model="formation.dateOuverture"
              @input="showCalendarDebut = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="showCalendarFin"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formatedDateFermeture"
                label="Date fermeture *"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
                autofocus
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="fr-fr"
              :min="minDateOuverture"
              :max="maxDateFermeture"
              v-model="formation.dateFermeture"
              @input="showCalendarFin = false"
            ></v-date-picker>
          </v-menu>
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Référents pédagogiques</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <Referents
                  :referents="formation.referents"
                  typeReferent="referentsEnseignant"
                  @addReferent="onAddReferent"
                  @deleteReferent="onDeleteReferent"
                >
                </Referents>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Types de pièce</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <ListeTypesPiece
                  :piecesAFournir="formation.piecesAFournir"
                  @addPiece="onAddPiece"
                  @dissocierPiece="onDissocierPiece"
                ></ListeTypesPiece>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="valider"
                  :loading="loading"
                >
                  <v-icon left>save</v-icon>Valider
                </v-btn>
                <router-link
                  :to="{
                    name: 'boListFormations',
                  }"
                >
                  <v-btn class="ma-2" color="primary">Retour</v-btn>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ListeTypesPiece from "@/components/ListeTypesPiece";
import Referents from "@/components/Referents";
import moment from "moment";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiCampusRepository from "@/repositories/ApiCampusRepository";
import ApiStructureRepository from "@/repositories/ApiStructureRepository";
import { mapState } from "vuex";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormEditionFormation",
  components: { BaseBlock, ListeTypesPiece, Referents, BaseAlert },
  extends: BaseForm,
  props: ["idFormation"],
  data() {
    return {
      valid: false,
      showCalendarDebut: false,
      showCalendarFin: false,
      loading: false,
      itemsStructure: [],
      itemsCampus: [],
      itemsDiplome: [],
      itemsNiveau: [],
      formation: {},
      libelleRules: [(v) => !!v || "Le libelle est requis"],
      dateRules: [(v) => !!v || "La date est requise"],
      // date min ouverture dans l'année universitaire
      jrMinDate: "01",
      moisMinDate: "08", // 08 -> Septembre
      // date max ouverture dans l'année universitaire
      jrMaxDate: "31",
      moisMaxDate: "07", // 07 -> Août
    };
  },
  computed: {
    ...mapState(["user"]),
    formatedDateOuverture: {
      get() {
        return this.formation.dateOuverture
          ? moment(this.formation.dateOuverture).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.formation.dateOuverture = value;
      },
    },
    formatedDateFermeture: {
      get() {
        return this.formation.dateFermeture
          ? moment(this.formation.dateFermeture).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.formation.dateFermeture = value;
      },
    },
    minDateOuverture() {
      return moment().format("MM") > 8
        ? moment([
            moment().format("YYYY"),
            this.moisMinDate,
            this.jrMinDate,
          ]).format("YYYY-MM-DD")
        : moment([
            moment().subtract(1, "years").format("YYYY"),
            this.moisMinDate,
            this.jrMinDate,
          ]).format("YYYY-MM-DD");
    },
    maxDateFermeture() {
      return moment().format("MM") > 8
        ? moment([
            moment().add(1, "years").format("YYYY"),
            this.moisMaxDate,
            this.jrMaxDate,
          ]).format("YYYY-MM-DD")
        : moment([
            moment().format("YYYY"),
            this.moisMaxDate,
            this.jrMaxDate,
          ]).format("YYYY-MM-DD");
    },
  },
  methods: {
    async valider() {
      try {
        this.loading = true;
        const boFormation = await ApiFormationRepository.updateFormation(
          this.formation
        );
        this.formation = boFormation;
        this.$toast.success("La formation a été mise à jour");
        this.error.messages = undefined;
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
      }
    },
    async getBOFormation() {
      try {
        const boFormation = await ApiFormationRepository.getBOFormation(
          this.idFormation
        );
        this.formation = boFormation;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getTypeDiplomes() {
      try {
        const typesDiplome = await ApiFormationRepository.getTypesDiplomes();
        this.itemsDiplome = typesDiplome;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getCampusLst() {
      try {
        const campusLst = await ApiCampusRepository.getCampusLst();
        this.itemsCampus = campusLst;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getStructuresLst() {
      try {
        const structuresLst = await ApiStructureRepository.getListeStructures();
        this.itemsStructure = structuresLst;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getNiveauxFormations() {
      try {
        const niveaux = await ApiFormationRepository.getNiveauxFormations();
        this.itemsNiveau = niveaux;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    onAddReferent(currentReferent) {
      this.formation.referents.push(currentReferent);
    },
    onDeleteReferent(currentReferent) {
      this.formation.referents = this.formation.referents.filter(
        (referent) => referent.uid !== currentReferent.uid
      );
    },
    onAddPiece(pieceAjout) {
      this.formation.piecesAFournir.unshift({
        id: pieceAjout.id,
        libelle: pieceAjout.libelle,
        obligatoire: true,
      });
    },
    onDissocierPiece(idTypePiece) {
      this.formation.piecesAFournir.splice(
        this.formation.piecesAFournir.findIndex((p) => p.id === idTypePiece),
        1
      );
    },
  },
  created() {
    if (this.user.roles.indexOf("ROLE_ADMIN") > -1) {
      this.getTypeDiplomes();
      this.getCampusLst();
      this.getStructuresLst();
      this.getNiveauxFormations();
    }
    this.getBOFormation();
  },
};
</script>
